module.exports = __webpack_public_path__ + "static/media/ic_eraser.99f759a5.svg";